var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46249 6.24585C6.46249 6.01803 6.64717 5.83334 6.87499 5.83334C7.10281 5.83334 7.2875 6.01803 7.2875 6.24585V14.4048L9.71247 11.9554C9.87356 11.7927 10.1347 11.7927 10.2958 11.9554C10.4569 12.1181 10.4569 12.3819 10.2958 12.5446L7.20988 15.6617C7.18463 15.6968 7.15403 15.7277 7.11927 15.7533L7.08731 15.7856C7.08502 15.7832 7.08275 15.7809 7.0805 15.7786C7.01999 15.8134 6.94982 15.8333 6.87499 15.8333C6.80016 15.8333 6.72999 15.8134 6.66948 15.7786L6.66267 15.7856L6.63069 15.7533C6.59595 15.7277 6.56536 15.6968 6.54013 15.6618L3.45414 12.5446C3.29305 12.3819 3.29305 12.1181 3.45414 11.9554C3.61524 11.7927 3.87642 11.7927 4.03751 11.9554L6.46249 14.4048V6.24585Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5375 13.7542C13.5375 13.982 13.3528 14.1667 13.125 14.1667C12.8972 14.1667 12.7125 13.982 12.7125 13.7542V5.59517L10.2875 8.04461C10.1264 8.20733 9.86526 8.20733 9.70417 8.04461C9.54307 7.88189 9.54307 7.61807 9.70417 7.45535L12.7901 4.33825C12.8154 4.30322 12.846 4.27232 12.8807 4.24673L12.9127 4.21445C12.915 4.21676 12.9172 4.21908 12.9195 4.22141C12.98 4.18658 13.0502 4.16666 13.125 4.16666C13.1998 4.16666 13.27 4.18658 13.3305 4.22141L13.3373 4.21445L13.3693 4.24675C13.4041 4.27233 13.4346 4.30322 13.4599 4.33822L16.5459 7.45535C16.707 7.61807 16.707 7.88189 16.5459 8.04461C16.3848 8.20733 16.1236 8.20733 15.9625 8.04461L13.5375 5.59516V13.7542Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.f260c11e0f2618148691a9456378c976.svg";
export { ForwardRef as ReactComponent };